import { TRUST_STATS } from "@/lib/siteData";

export const TrustBar = () => {
  const marqueeItems = [
    "100+ Campaigns",
    "₹5Cr+ Revenue",
    "Pan India",
    "Real Estate",
    "Lifestyle",
    "Education",
    "ROI-First",
    "Transparent Reporting",
  ];

  return (
    <section
      id="trust"
      data-testid="trust-bar"
      className="relative py-14 border-y border-[#E3A21A]/10 bg-[#1E2A1E]/40 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
          {TRUST_STATS.map((s, i) => (
            <div
              key={i}
              data-testid={`trust-stat-${i}`}
              className="flex items-baseline gap-4 group"
            >
              <div className="font-display text-4xl md:text-5xl font-semibold text-[#E3A21A] tracking-tight">
                {s.value}
              </div>
              <div className="text-sm md:text-base text-[#A8B8A8] leading-tight">
                {s.label}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Marquee ticker */}
      <div className="mt-10 overflow-hidden border-t border-[#E3A21A]/5 pt-6">
        <div className="flex marquee-track gap-12 whitespace-nowrap">
          {[...marqueeItems, ...marqueeItems].map((m, i) => (
            <div key={i} className="flex items-center gap-3">
              <span className="h-1.5 w-1.5 rounded-full bg-[#E3A21A]" />
              <span className="text-[11px] tracking-[0.25em] uppercase text-[#A8B8A8] font-semibold">
                {m}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
